// University of Illinois Urbana-Champaign's undergraduate majors (#2652).
// Read on 2026-10-01 from the official 2026-2027 Academic Catalog's
// Undergraduate Majors & Concentrations page (catalog.illinois.edu), which
// lists every program with its degree and links it under the college that
// offers it. The college here is the one in each program's catalog address
// (aces, ahs, bus, education, engineering, faa, las, media, ischool, socw);
// joint codes (eng_las, eng_faa, eng_media, eng_aces) sit under the college
// whose catalog page lists them, with a note naming the partner. Agricultural
// & Biological Engineering is listed by both ACES and Engineering and appears
// once, under Engineering. Left out: concentrations, minors, the four
// "Undeclared" entries, the two dual-degree pairings (ABE BS with BSAG, and
// Dance BA with Kinesiology BS) and repeated cross-listings (e.g. "Music -
// Instrumental Music" and "Teaching of French" point to the same programs).
// Degree abbreviations are the catalog's own (BS, BSLAS, BALAS, BFA, BMUS...).
// The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-illinois-urbana-champaign",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in the University of Illinois Urbana-Champaign's 2026-2027 Academic Catalog, grouped by the college that offers it, with the degree it leads to. Concentrations, minors, undeclared options, dual-degree pairings and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agricultural, Consumer & Environmental Sciences",
            "source": {
                "label": "Illinois 2026-2027 Academic Catalog, Undergraduate Majors & Concentrations",
                "url": "https://catalog.illinois.edu/undergraduate/"
            },
            "majors": [
                {
                    "name": "Agricultural & Consumer Economics",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Leadership, Education, & Communications",
                    "degree": "BS"
                },
                {
                    "name": "Agronomy",
                    "degree": "BS"
                },
                {
                    "name": "Animal Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science + Animal Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science + Crop Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Crop Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Dietetics and Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Technology & Management for Agricultural Systems",
                    "degree": "BS"
                },
                {
                    "name": "Financial Planning",
                    "degree": "BS"
                },
                {
                    "name": "Food Science",
                    "degree": "BS"
                },
                {
                    "name": "Hospitality Management",
                    "degree": "BS"
                },
                {
                    "name": "Human Development & Family Studies",
                    "degree": "BS"
                },
                {
                    "name": "Natural Resources & Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition and Health",
                    "degree": "BS"
                },
                {
                    "name": "Plant Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Public Policy and Law",
                    "degree": "BS"
                },
                {
                    "name": "Sustainability in Food & Environmental Systems",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Applied Health Sciences",
            "source": {
                "label": "Illinois 2026-2027 Academic Catalog, Undergraduate Majors & Concentrations",
                "url": "https://catalog.illinois.edu/undergraduate/"
            },
            "majors": [
                {
                    "name": "Community Health",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Recreation, Sport & Tourism",
                    "degree": "BS"
                },
                {
                    "name": "Speech & Hearing Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "Illinois 2026-2027 Academic Catalog, Undergraduate Majors & Concentrations",
                "url": "https://catalog.illinois.edu/undergraduate/"
            },
            "majors": [
                {
                    "name": "Computer Science + Education",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS"
                },
                {
                    "name": "Learning & Education Studies",
                    "degree": "BS"
                },
                {
                    "name": "Middle Grades Education",
                    "degree": "BS"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BS"
                },
                {
                    "name": "Special Education",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Fine & Applied Arts",
            "source": {
                "label": "Illinois 2026-2027 Academic Catalog, Undergraduate Majors & Concentrations",
                "url": "https://catalog.illinois.edu/undergraduate/"
            },
            "majors": [
                {
                    "name": "Architectural Studies",
                    "degree": "BS"
                },
                {
                    "name": "Art & Art History",
                    "degree": "BFA"
                },
                {
                    "name": "Art Education",
                    "degree": "BFA"
                },
                {
                    "name": "Computer Science + Music",
                    "degree": "BS",
                    "note": "Offered jointly with the Grainger College of Engineering."
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Fine and Applied Arts",
                    "degree": "BA"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Hip Hop Culture and the Arts",
                    "degree": "BA"
                },
                {
                    "name": "Immersive & Interactive Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Industrial Design",
                    "degree": "BFA"
                },
                {
                    "name": "Instrumental Music",
                    "degree": "BMUS"
                },
                {
                    "name": "Jazz Performance",
                    "degree": "BMUS"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                },
                {
                    "name": "Lyric Theatre",
                    "degree": "BMA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music - Open Studies",
                    "degree": "BMUS"
                },
                {
                    "name": "Music - Voice",
                    "degree": "BMUS"
                },
                {
                    "name": "Music Composition",
                    "degree": "BMUS"
                },
                {
                    "name": "Music Education",
                    "degree": "BME"
                },
                {
                    "name": "Musicology",
                    "degree": "BMUS"
                },
                {
                    "name": "Studio Art",
                    "degree": "BASA"
                },
                {
                    "name": "Studio Art",
                    "degree": "BFASA"
                },
                {
                    "name": "Sustainable Design",
                    "degree": "BS"
                },
                {
                    "name": "Theatre",
                    "degree": "BFA"
                },
                {
                    "name": "Urban Studies & Planning",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Liberal Arts & Sciences",
            "source": {
                "label": "Illinois 2026-2027 Academic Catalog, Undergraduate Majors & Concentrations",
                "url": "https://catalog.illinois.edu/undergraduate/"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": "BSLAS"
                },
                {
                    "name": "African American Studies",
                    "degree": "BALAS"
                },
                {
                    "name": "Anthropology",
                    "degree": "BALAS"
                },
                {
                    "name": "Art History",
                    "degree": "BALAS"
                },
                {
                    "name": "Asian American Studies",
                    "degree": "BALAS"
                },
                {
                    "name": "Astronomy",
                    "degree": "BSLAS"
                },
                {
                    "name": "Astronomy + Data Science",
                    "degree": "BSLAS"
                },
                {
                    "name": "Astrophysics",
                    "degree": "BSLAS"
                },
                {
                    "name": "Atmospheric Sciences",
                    "degree": "BSLAS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Brain & Cognitive Science",
                    "degree": "BSLAS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering + Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BSLAS"
                },
                {
                    "name": "Classics",
                    "degree": "BALAS"
                },
                {
                    "name": "Communication",
                    "degree": "BALAS"
                },
                {
                    "name": "Comparative & World Literature",
                    "degree": "BALAS"
                },
                {
                    "name": "Computer Science + Anthropology",
                    "degree": "BSLAS",
                    "note": "Offered jointly with the Grainger College of Engineering."
                },
                {
                    "name": "Computer Science + Astronomy",
                    "degree": "BSLAS",
                    "note": "Offered jointly with the Grainger College of Engineering."
                },
                {
                    "name": "Computer Science + Chemistry",
                    "degree": "BSLAS",
                    "note": "Offered jointly with the Grainger College of Engineering."
                },
                {
                    "name": "Computer Science + Economics",
                    "degree": "BSLAS",
                    "note": "Offered jointly with the Grainger College of Engineering."
                },
                {
                    "name": "Computer Science + Geography & Geographic Information Science",
                    "degree": "BSLAS",
                    "note": "Offered jointly with the Grainger College of Engineering."
                },
                {
                    "name": "Computer Science + Linguistics",
                    "degree": "BSLAS",
                    "note": "Offered jointly with the Grainger College of Engineering."
                },
                {
                    "name": "Computer Science + Philosophy",
                    "degree": "BSLAS",
                    "note": "Offered jointly with the Grainger College of Engineering."
                },
                {
                    "name": "Creative Writing",
                    "degree": "BALAS"
                },
                {
                    "name": "Earth, Society, & Environmental Sustainability",
                    "degree": "BSLAS"
                },
                {
                    "name": "East Asian Languages & Cultures",
                    "degree": "BALAS"
                },
                {
                    "name": "Econometrics & Quantitative Economics",
                    "degree": "BSLAS"
                },
                {
                    "name": "Economics",
                    "degree": "BALAS"
                },
                {
                    "name": "English",
                    "degree": "BALAS"
                },
                {
                    "name": "Environmental Sustainability",
                    "degree": "BSLAS"
                },
                {
                    "name": "French",
                    "degree": "BALAS"
                },
                {
                    "name": "French (Teaching)",
                    "degree": "BA"
                },
                {
                    "name": "Gender & Women's Studies",
                    "degree": "BALAS"
                },
                {
                    "name": "Geography & Geographic Information Science",
                    "degree": "BALAS"
                },
                {
                    "name": "Geography & Geographic Information Science",
                    "degree": "BSLAS"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BSLAS"
                },
                {
                    "name": "German (Teaching)",
                    "degree": "BA"
                },
                {
                    "name": "Germanic Studies",
                    "degree": "BALAS"
                },
                {
                    "name": "Global Studies",
                    "degree": "BALAS"
                },
                {
                    "name": "History",
                    "degree": "BALAS"
                },
                {
                    "name": "Individual Plans of Study",
                    "degree": "BALAS or BSLAS"
                },
                {
                    "name": "Integrative Biology",
                    "degree": "BSLAS"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BALAS"
                },
                {
                    "name": "Italian",
                    "degree": "BALAS"
                },
                {
                    "name": "Latin American Studies",
                    "degree": "BALAS"
                },
                {
                    "name": "Latina/Latino Studies",
                    "degree": "BALAS"
                },
                {
                    "name": "Liberal Studies",
                    "degree": "BLS"
                },
                {
                    "name": "Linguistics",
                    "degree": "BALAS"
                },
                {
                    "name": "Linguistics and Teaching English as a Second Language (TESL)",
                    "degree": "BALAS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BSLAS"
                },
                {
                    "name": "Mathematics & Computer Science",
                    "degree": "BSLAS",
                    "note": "Offered jointly with the Grainger College of Engineering."
                },
                {
                    "name": "Molecular & Cellular Biology",
                    "degree": "BSLAS"
                },
                {
                    "name": "Molecular and Cellular Biology + Data Science",
                    "degree": "BSLAS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BSLAS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BALAS"
                },
                {
                    "name": "Political Science",
                    "degree": "BALAS"
                },
                {
                    "name": "Portuguese",
                    "degree": "BALAS"
                },
                {
                    "name": "Psychology",
                    "degree": "BSLAS"
                },
                {
                    "name": "Religion",
                    "degree": "BALAS"
                },
                {
                    "name": "Russian, East European, & Eurasian Studies",
                    "degree": "BALAS"
                },
                {
                    "name": "Slavic Studies",
                    "degree": "BALAS"
                },
                {
                    "name": "Sociology",
                    "degree": "BALAS"
                },
                {
                    "name": "Spanish",
                    "degree": "BALAS"
                },
                {
                    "name": "Spanish (Teaching)",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BSLAS"
                },
                {
                    "name": "Statistics & Computer Science",
                    "degree": "BSLAS",
                    "note": "Offered jointly with the Grainger College of Engineering."
                }
            ]
        },
        {
            "name": "College of Media",
            "source": {
                "label": "Illinois 2026-2027 Academic Catalog, Undergraduate Majors & Concentrations",
                "url": "https://catalog.illinois.edu/undergraduate/"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science + Advertising",
                    "degree": "BS",
                    "note": "Offered jointly with the Grainger College of Engineering."
                },
                {
                    "name": "Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Media",
                    "degree": "BA"
                },
                {
                    "name": "Media & Cinema Studies",
                    "degree": "BS"
                },
                {
                    "name": "Sports Media",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Gies College of Business",
            "source": {
                "label": "Illinois 2026-2027 Academic Catalog, Undergraduate Majors & Concentrations",
                "url": "https://catalog.illinois.edu/undergraduate/"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "BS"
                },
                {
                    "name": "Accountancy + Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Business + Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Finance + Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Operations Management",
                    "degree": "BS"
                },
                {
                    "name": "Strategy, Innovation and Entrepreneurship",
                    "degree": "BS"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Grainger College of Engineering",
            "source": {
                "label": "Illinois 2026-2027 Academic Catalog, Undergraduate Majors & Concentrations",
                "url": "https://catalog.illinois.edu/undergraduate/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural & Biological Engineering",
                    "degree": "BS",
                    "note": "Offered jointly with the College of Agricultural, Consumer & Environmental Sciences."
                },
                {
                    "name": "Bioengineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science + Bioengineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science + Physics",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Mechanics",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Innovation, Leadership & Engineering Entrepreneurship",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science & Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science & Engineering + Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Neural Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Nuclear, Plasma, & Radiological Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Nuclear, Plasma, and Radiological Engineering + Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Systems Engineering and Design",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Information Sciences",
            "source": {
                "label": "Illinois 2026-2027 Academic Catalog, Undergraduate Majors & Concentrations",
                "url": "https://catalog.illinois.edu/undergraduate/"
            },
            "majors": [
                {
                    "name": "Information Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Information Sciences + Data Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "Illinois 2026-2027 Academic Catalog, Undergraduate Majors & Concentrations",
                "url": "https://catalog.illinois.edu/undergraduate/"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        }
    ]
};

export default majors;
